import { useMemo } from "react";
import getConversationMediaFileIds, {} from "../common/getConversationMediaFileIds";
/**
 * The files a chat can step through, for whichever surface opens one of its images. The list is
 * assembled from the loaded messages, so a long chat steps through part of its images; callers only
 * ever read `fileIds`, so a fetched and paged list can replace the assembly without reaching them.
 */
// TODO(muhammad): [NX-12779] fetch and page the list from the per-conversation endpoint once it ships.
export default function useConversationMediaFiles({ messages }) {
    const fileIds = useMemo(() => getConversationMediaFileIds(messages), [messages]);
    return useMemo(() => ({ fileIds }), [fileIds]);
}
